import { useState, useEffect } from "react";
import "./HomePageCss/OurPackageSection.css";
import { useNavigate } from "react-router-dom";
import cornerIcon from "../../Assets/cornerIcon.png";
import AnimatedText from "../../AnimatedText";
import rbdLogo from "../../Assets/rbdLogo.png";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

import { useCart } from "../../Contexts/Cart.contexts";
import PackageDetailsModal from "../OurPackagesPageElements/PackageDetailsModel";
import { getDiscountedPrice } from "../OurPackagesPageElements/OurPackageMainSection";
import { getPackageList } from "../../api/api";
import { TruncateText } from "../../common/TruncateText";
import { Autoplay, Navigation } from "swiper/modules";
import ViewPackageDetails from "../OurPackagesPageElements/ViewPackageDetails";

export default function OurPackage() {
  const discount = 11;

  const { addToCart, cartItems ,setCartItems} = useCart();

  const handleAddToCart = (packageData) => {
    // addToCart({
    //   id: Date.now().toString() + Math.random().toString(36).substr(2, 5),
    //   product: packageData.title,
    //   price: packageData.price,
    //   quantity: 1,
    // });
    const exists = cartItems.some((item) => item.id === packageData.service_id);
    if (exists) {
      return;
    }
    addToCart({
      id: packageData.service_id,
      product: packageData.service_name,
      price: packageData.price,
      quantity: 1,
    });
  };

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [packageList, setPackageList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPackageListData();
  }, []);

  const fetchPackageListData = async () => {
    const payload = {
      search_key: "",
    };
    try {
      setLoading(true);
      const res = await getPackageList(payload);
      const filterShowInWeb = res?.data?.data?.filter(
        (item) => item.ShowInWeb === "Y"
      );
      setPackageList(filterShowInWeb || []);
    } catch (error) {
      console.error("Error fetching Package list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (card) => {
    setSelectedPackage(card);
    setIsModalOpen(true);
  };

  const [renderMode, setRenderMode] = useState("buttons");
  const [isMobile, setIsMobile] = useState(false);
  const navigator = useNavigate();
  const [activeTab, setActiveTab] = useState("General Wellness");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 480);
      if (width <= 768) {
        setRenderMode("dropdown");
      } else {
        setRenderMode("buttons");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const categories = [
    "General Wellness",
    "Lifestyle",
    "Gynecology Packages",
    "Offers",
  ];

  const getCardsForCategory = (category) => {
    const data = {
      "General Wellness": [
        {
          title: "Serology Profile",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["4 Tests", "7 Components"],
          price: 1600.0,
        },
        {
          title: "KFT (Kidney Function Test)",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["7 Tests", "7 Components"],
          price: 1300.0,
        },
        {
          title: "RBD Healthy Life, Blood (Female)",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["21 Tests", "93 Components"],
          price: 6500.0,
        },
        {
          title: "KFT (Kidney Function Test)",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["7 Tests", "7 Components"],
          price: 1300.0,
        },
      ],
      Lifestyle: [
        {
          title: "Fitness Pro Package",
          TestsAndComp: ["25 Tests", "68 Components"],
          parameters: ["Laboratory Tests", "Radiology Tests"],
          price: 2799.0,
        },
        {
          title: "Smoker’s Risk Assessment",
          TestsAndComp: ["10 Tests", "25 Components"],
          parameters: ["Laboratory Tests", "Radiology Tests"],
          price: 1899.0,
        },
        {
          title: "Stress & Sleep Health Panel",
          TestsAndComp: ["6 Tests", "18 Components"],
          parameters: ["Laboratory Tests", "Radiology Tests"],
          price: 1299.0,
        },
        {
          title: "Nutritional Health Screening",
          TestsAndComp: ["14 Tests", "30 Components"],
          parameters: ["Laboratory Tests", "Radiology Tests"],
          price: 1699.0,
        },
      ],
      "Gynecology Packages": [
        {
          title: "Women’s Hormonal Profile",
          TestsAndComp: ["9 Tests", "21 Components"],
          parameters: ["Laboratory Tests", "Radiology Tests"],
          price: 2299.0,
        },
        {
          title: "PCOD/PCOS Screening",
          TestsAndComp: ["7 Tests", "17 Components"],
          price: 1999.0,
        },
        {
          title: "Pregnancy Wellness Package",
          TestsAndComp: ["12 Tests", "30 Components"],
          parameters: ["Laboratory Tests", "Radiology Tests"],
          price: 2599.0,
        },
        {
          title: "Anaemia Panel (Female)",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["5 Tests", "14 Components"],
          price: 899.0,
        },
      ],
      Offers: [
        {
          title: "RBD Smart Combo - 1",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["30 Tests", "88 Components"],
          price: 1799.0,
        },
        {
          title: "Weekend Special - Wellness Check",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["22 Tests", "56 Components"],
          price: 1199.0,
        },
        {
          title: "Buy 1 Get 1 Free - Basic Panel",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["15 Tests", "40 Components"],
          price: 999.0,
        },
        {
          title: "Festive Health Pack",
          parameters: ["Laboratory Tests", "Radiology Tests"],
          TestsAndComp: ["28 Tests", "75 Components"],
          price: 1499.0,
        },
      ],
    };

    return data[category] || [];
  };

  const cards = getCardsForCategory(activeTab);

  function topRankedList(cards) {
    return cards.sort((a, b) => b.Ranking - a.Ranking);
  }

  return (
    <div className="ourPackageContainer contactUsSection">
      <div className="ourPackageUpperSection">
        <AnimatedText
          tag="h2"
          type="words"
          y={30}
          className="rb-title ourpackageTitle"
        >
          Our Packages
        </AnimatedText>

        <div className="textParaSection">
          <p className="paraText">
            RB Diagnostic offers a comprehensive range of health check-up
            packages tailored for every stage of life.
          </p>
          <p className="paraText">
            Each package is designed by experts to provide accurate insights and
            support preventive healthcare, ensuring timely diagnosis and better
            health outcomes.
          </p>
          {/* <button className="viewAllBtn" onClick={() => navigator("/packages")}>
    View All →
  </button> */}

          {/* <AnimatedText tag="p" type="words" y={-20} className="paraText">
            RB Diagnostic offers a comprehensive range of health check-up packages tailored for every stage of life.
          </AnimatedText>
          <AnimatedText tag="p" type="words" y={-20} className="paraText">
            Each package is designed by experts to provide accurate insights and support preventive healthcare, ensuring timely diagnosis and better health outcomes.
          </AnimatedText> */}
        </div>
      </div>

      {/* <div className="midNavButtons">
        {renderMode === "dropdown" ? (
          <select
            className="mobileDropdown"
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value)}
          >
            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        ) : (
          <div className="buttonContainer">
            {categories.map((category) => (
              <button
                key={category}
                className={`navBtn ${activeTab === category ? "active" : ""}`}
                onClick={() => setActiveTab(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}
      </div> */}

      <div className="ourPackageCardSection package-card-swipers">
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 5,
          }}
          spaceBetween={20}
          watchOverflow={true}
          breakpoints={{
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1, // ✅
            },
            480: {
              slidesPerView: 1.1,
              slidesPerGroup: 1, // ✅
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2, // ✅ BIG FIX
            },
            1024: {
              slidesPerView: 3,
              slidesPerGroup: 4, // ✅
            },
            1280: {
              slidesPerView: 4,
              slidesPerGroup: 5, // ✅
            },
            1400: {
              slidesPerView: 5,
              slidesPerGroup: 5, // ✅
            },
          }}
        >
          {packageList.map((card, index) => {
            const isAdded = cartItems.some(
              (item) => item.id === card.service_id
            );

            const handleToggleCart = () => {
              if (isAdded) {
                setCartItems((prev) =>
                  prev.filter((item) => item.id !== card.service_id)
                );
              } else {
                handleAddToCart(card);
              }
            };

            return (
              <SwiperSlide key={index}>
                <div className="packageCard mainPackageCard home-slider-card">
                  <div className="cornerImage">
                    <div className="upperCardText">
                      <img className="logoimg" src={rbdLogo} alt="RBD logo" />
                    </div>
                    <img
                      className="rightCornerLogo"
                      src={cornerIcon}
                      alt="corner icon"
                      style={{ width: "3.5rem" }}
                    />
                  </div>

                  <div className="cardTitlePack mainpackageTitlePack">
                    <h3 style={{ margin: "5px 0px" }}>
                      <TruncateText text={card?.service_name} maxLength={35} />
                    </h3>
                  </div>

                  <span className="testAndComp" style={{ color: "darkcyan" }}>
                    <p>
                      Covers {card?.list.length} Tests with {card?.NoOfParams}{" "}
                      components
                    </p>

                    {card.parameters && card.parameters.length > 0 && (
                      <div className="cardParameters">
                        <h4 style={{ fontSize: "15px", fontWeight: 700 }}>
                          Parameters
                        </h4>
                        <ul style={{ paddingLeft: "20px" }}>
                          {card?.list.map((param, idx) => (
                            <li key={idx} style={{ fontSize: "13px" }}>
                              {param}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </span>

                  <div className="priceSection">
                    <h2 style={{ fontSize: "15px", color: "red" }}>
                      <del>₹ {card.PackageRate}/-</del>
                    </h2>
                    <h2 style={{ fontSize: "15px", color: "green" }}>
                      {card?.priceOff}% Off
                    </h2>
                    <h2 style={{ color: "grey", fontSize: "16px" }}>
                      ₹ {Number(card.price)}/-
                    </h2>
                  </div>

                  <div className="cardLowerSec">
                    <button
                      className="rbdButton"
                      onClick={() => handleViewDetails(card)}
                    >
                      <span className="btn-text">View Details</span>
                    </button>
                    <button
                      className={`rbdButton addCartBtn ${
                        isAdded ? "added" : ""
                      }`}
                      onClick={handleToggleCart}
                      title={isAdded ? "Remove from cart" : "Add to cart"}
                    >
                      <span className="btn-text">
                        {isAdded ? "Remove" : "Add to Cart"}
                      </span>
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

        <span
          className="viewAllBtn"
          onClick={() => navigator("/service/OurPackagesPage")}
        >
          View All →
        </span>
      </div>

      <ViewPackageDetails
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        packageData={selectedPackage}
      />

      {/* <PackageDetailsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          packageData={selectedPackage}
        /> */}
    </div>
  );
}
